<template>
  <app-header></app-header>
  <section class="catalog products">
    <swiper
      :loop="true"
      :modules="modules"
      :pagination="{ clickable: true }"
      :slides-per-view="1"
      :autoplay="{ delay: 3000, disableOnInteraction: false }"
      v-if="slides.length > 0"
    >
      <swiper-slide v-for="(item, index) in slides" :key="index" class="slide-item">
        <a v-if="item.type === 'link'" :href="item.url" target="_blank">
          <img :src="item.src" :alt="item.alt" />
        </a>
        <router-link v-else :to="`/${currentLanguage}/${item.route}`" target="_blank">
          <img :src="item.src" :alt="item.alt" />
        </router-link>
      </swiper-slide>
      <div class="swiper-pagination"></div>
    </swiper>
    <div class="title-box">
      <h1 class="title">{{ $t('products.key001') }}</h1>
    </div>
    <div class="products-list">
      <div class="product-item" v-for="product in products.data" :key="product.id">
        <div class="product-info" @click="viewProduct(product.id)">
          <img :src="product.image" alt="" class="" />
          <div class="text-info">
            <div class="time">
              <p>
                <i class="bi bi-calendar-week"></i>
                <span>{{ product.time }}</span>
              </p>
            </div>
            <div class="text">
              <h2 class="title" :title="product.name">
                {{ product.name }}
              </h2>
            </div>
          </div>
          <button class="go-to">{{ $t('products.key002') }}</button>
        </div>
      </div>
    </div>
  </section>
  <app-footer></app-footer>
  <Loading v-show="loading"></Loading>
</template>

<script>
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import { getProducts } from '@/api/cartService.js';
import Loading from '@/components/Loading.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { formatTimeRange } from '@/utils/formatTimeRange';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
  name: 'EmptyPage',
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    Loading,
    Swiper,
    SwiperSlide,
  },
  props: {},
  setup() {
    return {
      modules: [Autoplay, Navigation, Pagination],
    };
  },
  data() {
    return {
      slides: [],
      products: [],
      loading: false,
    };
  },
  async mounted() {
    await this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      try {
        this.loading = true;
        const langSetting = this.currentLanguage === 'zh_tw' ? 'zh-tw' : this.currentLanguage;
        const response = await getProducts(langSetting);

        this.products = response.data;
        const productsData = this.products.data;

        if (productsData) {
          productsData.forEach((item) => {
            if (item.startTime && item.endTime) {
              item.time = formatTimeRange(item.startTime, item.endTime, true);
            }
          });
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        this.loading = false;
      }
    },
    viewProduct(productId) {
      this.$router.push({
        path: `/${this.currentLanguage}/product-info/${productId}`,
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/components/catalog.scss';
</style>
